<template>
  <div>
    Task
    <vue-apex-charts type="pie" height="350" :options="pieChart.chartOptions" :series="pieChart.series"></vue-apex-charts>

    <li v-for="task in tasks" :key="task.id">
      {{task.title}}
    </li>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: ['tasks'],
  data () {
    return {
      // periodOptions: ['today', 'yesterday', 'this week', 'last week', 'this month', 'last month']
      pieChart: {
        series: [44, 55, 13, 43],
        chartOptions: {
          labels: ['Team A', 'Team B', 'Team C', 'Team D'],
          colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
      }
    }
  },
  methods: {

  },
  // watch: {
  //   'reviewPopupOpen': {
  //     immediate: false,
  //     handler (reviewPopupOpen) {
  //       this.popupActive = reviewPopupOpen
  //     }
  //   },
  //   'popupActive': {
  //     immediate: false,
  //     handler (popupActive) {
  //       if (!popupActive) {

  //       }
  //     }
  //   }
  // },

  computed: {


  },

}
</script>
